/**
 * @name setCategorySort.js
 */

class setCategorySort {
    constructor() {
        // DOM
        this.catList = this.flag;
        this.currentCat = document.querySelector('[data-sort-cat]');
        this.jobItem = document.querySelectorAll('.p-job-list__items .list-item');
        this.modalItem = document.querySelectorAll('.p-job-modal__slider .modal-item');
        this.catBtn = document.querySelectorAll('.category-list [name="category"]');
        this.none = document.querySelector('.p-job-list__none');

        this.__init();
    }
    /**
 * @name __init
 */
    __init() {
        this.__event();
        this.__updateDisplay();
    }

    /**
     * @name __event
     */
    __event() {

        // カテゴリボタンをクリックした時の処理
        this.catBtn.forEach(btn => {
            btn.addEventListener('change', (e) => {
                const cat = e.target.value;
                this.__update('cat', cat).updateUrl();
                this.__updateDisplay();
            });
        });

        // URLのクエリパラメータを取得してカテゴリをセット
        const updateCurrent = () => {
            const url = new URL(location.href);
            const cat = url.searchParams.getAll('cat');

            const updateButtons = (buttons, values) => {
                buttons.forEach(btn => {
                    btn.checked = values.includes(btn.value);
                });
            };

            updateButtons(this.catBtn, cat);
            this.__updateDisplay();
        }

        // 読み込んだ時の処理
        window.addEventListener('load', updateCurrent);

        // 戻る、進むボタンを押した時の処理
        window.addEventListener('popstate', updateCurrent);
    }

    /**
     * @name __update
     */
    __update(type, value) {

        // URLにクエリパラメータを追加
        const updateUrl = () => {
            let url = new URL(location.href);
            let params = url.searchParams.getAll(type);

            // 同じパラメータがある場合は削除
            if (params.includes(value)) {
                params = params.filter(param => param !== value);
            } else {
                params.push(value);
            }

            url.searchParams.delete(type);
            params.forEach(param => url.searchParams.append(type, param));
            history.replaceState(null, '', url.toString());
        }

        // ソートするカテゴリまたはタグをセット
        const updateAttribute = () => {
            let currentValues = this.currentTag.dataset[`sort${type.charAt(0).toUpperCase() + type.slice(1)}`] ? this.currentTag.dataset[`sort${type.charAt(0).toUpperCase() + type.slice(1)}`].split(',') : [];

            // 同じ値がある場合は削除
            if (currentValues.includes(value)) {
                currentValues = currentValues.filter(currentValue => currentValue !== value);
            } else {
                currentValues.push(value);
            }

            this.currentTag.dataset[`sort${type.charAt(0).toUpperCase() + type.slice(1)}`] = currentValues.join(',');
        }

        return {
            updateUrl,
            updateAttribute,
        };
    }

    /**
     * @name __updateDisplay
     */
    __updateDisplay() {
        const url = new URL(location.href);
        const categories = url.searchParams.getAll('cat');

        const updateItemsDisplay = (items, slide = false) => {
            items.forEach(item => {
                const itemCategories = item.dataset.category ? item.dataset.category.split(',') : [];

                const matchCategory = categories.some(cat => itemCategories.includes(cat));

                if (categories.length === 0) {
                    item.dataset.active = 'true';
                    slide ? item.classList.add('splide__slide') : '';
                    this.none.style.display = 'none';
                    return;
                }

                if (matchCategory) {
                    item.dataset.active = 'true';
                    slide ? item.classList.add('splide__slide') : '';
                    this.none.style.display = 'none';
                } else {
                    item.dataset.active = 'false';
                    slide ? item.classList.remove('splide__slide') : '';
                }
            });
        };

        updateItemsDisplay(this.jobItem, false);
        updateItemsDisplay(this.modalItem, true);

        if (this.jobItem.length === document.querySelectorAll('.p-job-list__items .list-item[data-active="false"]').length) {
            this.none.style.display = 'block';
        }
    }
}

export default setCategorySort;